import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs';
import { HttpClient, HttpContext } from '@angular/common/http';
import { CoreTargetService } from './target.service';
import { LocalStorageService } from './local-storage.service';
import { FORCE_REGION } from '../http/http-context.tokens';

@Injectable({
  providedIn: 'root',
})
export class CoreUserService {
  constructor(
    private _http: HttpClient,
    private coreTargetService: CoreTargetService,
    private localStorageService: LocalStorageService,
  ) {}
  private user: any = null;
  private isLoading: any = new BehaviorSubject(false);

  public saveUserInfo(user: any): void {
    this.user = { ...user };
  }

  public getUserInfo(): any {
    return { ...this.user };
  }

  public clearUserInfo(): void {
    this.user = null;
  }

  public getLoading(): Observable<any> {
    return this.isLoading.asObservable();
  }

  public setLoading(value: boolean): void {
    this.isLoading.next(value);
  }

  public verifyShopifyUser(token: string): Observable<any> {
    return this._http.get<any>(`/auth/shopify?shopifyToken=${token}`, {
      context: new HttpContext().set(FORCE_REGION, 'west-eu'),
    });
  }

  // api
  // public getUserFromApi(): Observable<any> {
  //   return this._http.get<any>(`/user-state`);
  // }
  // public getUserFromApi(): Observable<any> {
  //   const email = this.localStorageService.get('email');
  //   const target = this.coreTargetService.getSelectedTarget('target');

  //   let params = 'email=' + email;
  //   if (target) {
  //     params += '&target=' + target;
  //   }

  //   return this._http.get('/privileges/userPrivileges/user?' + params);
  // }
}
